import type { ReactNode } from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

const MERGEABILITY_BADGE_BOX_CLASS =
  'rounded-full border border-transparent px-2 py-0.5 text-xs font-medium';

/** The header's merge-status pill; `className` sets its tone. */
export function PrV2MergeabilityBadge({
  className,
  children,
}: {
  className: string;
  children: ReactNode;
}) {
  return <span className={cn(MERGEABILITY_BADGE_BOX_CLASS, className)}>{children}</span>;
}

/**
 * Stands in for the merge-status badge in the loading skeleton and while the status loads. It
 * shares the badge's box so their heights match; 120px is about the width of the common labels
 * ("Approval required", "Required CI failed"), so the author and diff stats beside it barely move
 * when the real label lands.
 */
export function PrV2MergeabilityBadgeSkeleton() {
  return (
    <Skeleton
      data-testid="pr-v2-mergeability-skeleton"
      aria-hidden
      className={cn(MERGEABILITY_BADGE_BOX_CLASS, 'w-30 text-transparent')}
    >
      {'\u00A0'}
    </Skeleton>
  );
}
